import { createAction } from '@reduxjs/toolkit';

export const REJECT_CALL_ACTION_TYPE = 'saga/rejectCall';
export const rejectCallAction = createAction(REJECT_CALL_ACTION_TYPE);
